import { CourseOption, CourseSummary } from "../types/course.response";
import { ProgramResponse, ProgramSummaryResponse } from "../types/program.response";
import { seedCatalog } from "../services/courseCatalog";

/**
 * 给 courses 字典的每个 value 回填它的 map key(契约:key 是后端产生的不透明字符串,
 * 前端从不手工构造;批量补水请求的 keys 一律取自这里)。
 */
export function stampMapKeys(
    courses: Record<string, Omit<CourseSummary, "mapKey">>,
): Record<string, CourseSummary> {
    const stamped: Record<string, CourseSummary> = {};
    for (const [key, course] of Object.entries(courses)) {
        stamped[key] = { ...course, mapKey: key };
    }
    return stamped;
}

/**
 * 完整 CourseOption 降为 CourseSummary(courses 字典 value 的轻形状)。
 * creditsMinimum/Maximum、defaultSemester 按后端去范式化口径取首个 enrollGroup。
 */
export function toCourseSummary(course: CourseOption, mapKey: string): CourseSummary {
    const defaultGroup = course.enrollGroups?.[0];
    return {
        userItemId: course.userItemId,
        id: course.id,
        topic: course.topic,
        type: course.type,
        courseInfo: course.courseInfo,
        userState: course.userState,
        courseState: course.courseState,
        combinedCourseInfo: course.combinedCourseInfo,
        creditsMinimum: defaultGroup?.creditsMinimum ?? null,
        creditsMaximum: defaultGroup?.creditsMaximum ?? null,
        defaultSemester: defaultGroup?.semester ?? null,
        mapKey,
    };
}

/**
 * 全量响应归一为 summary 形状,顺便把完整课程数据灌入 catalog 缓存
 * (全量数据天然已"补水")。用于 summary 端点不可用时的回退路径,
 * 以及尚未切换端点的页面 —— 页面内部统一持有 ProgramSummaryResponse。
 */
export function toProgramSummary(full: ProgramResponse): ProgramSummaryResponse {
    seedCatalog(full.courses);

    const courses: Record<string, CourseSummary> = {};
    for (const [key, course] of Object.entries(full.courses)) {
        courses[key] = toCourseSummary(course, key);
    }

    return { ...full, courses };
}
